import { AGRO_POWER } from 'constants/catalog';
import React from 'react';
import ProductList from './ProductList';

const AgroPowerList = () => {
    return <ProductList type={AGRO_POWER} />
}

export default AgroPowerList;